import { Icon } from "../../../../../../components";

type Props = {
  title: string;
  icon: string;
};

const IntegrationsKey = ({ title, icon }: Props) => (
  <div className="flex align-center flex-gap-2">
    <Icon
      name={icon}
      style={{ width: "15px", height: "15px", fontSize: "15px" }}
    />
    <span>{title}</span>
  </div>
);

export default IntegrationsKey;
